module.exports = __webpack_public_path__ + "static/media/001-payment.68083296.svg";